import React, { useState, useEffect } from "react";
import MultiLanguageTranslation from "../../../_components/Translate/MultiLangTranslate";
import MultiSelect from "../../../_components/_common/MultiSelect/MultiSelect";
import { CommonApiService } from "../../../_services/CommnService/CommonApiService";
import { authServices } from "../../../_services/Auth/AuthServices";
import { MdKeyboardBackspace } from "react-icons/md";
import { validateBuySell } from "../../../_helpers/Common/helper";
const init = {
  buyerLocation: [],
  buyerCommodity: [],
  sellerLocation: [],
  sellerCommodity: [],
};

const LoginSignupForm = (props) => {
  const [isBuySellOpOrLocationCommodity, setBuySellOpOrLocationCommodity] =
    useState(1);
  const [allcitys, setAllcitys] = useState([]);
  const [buyerSeller, setBuyerSeller] = useState(
    window.selectSupplyClick ? "seller" : "buyer"
  );
  const [locationAndCommodities, setLocationAndCommodities] = useState(init);
  const [error, setError] = useState({});
  const { options_master } = props.option;
  let isKyc = localStorage.getItem("isKyc");
  let userDashBoradData = JSON.parse(localStorage.getItem("userDashBoardData"));
  let fromTrade = userDashBoradData?.member?.from_trade == 1;
  useEffect(() => {
    getAllcity();
    return () => {
      delete window.selectSupplyClick;
    };
  }, []);
  useEffect(() => {
    setLocationAndCommodities(init);
    setError({});
  }, [isBuySellOpOrLocationCommodity]);

  useEffect(() => {
    if (props.isBuyLeads) {
      setBuyerSeller("buyer");
      setBuySellOpOrLocationCommodity(2);
    }
  }, [props.isBuyLeads]);

  useEffect(() => {
    if (props.isSellLeads) {
      setBuyerSeller("seller");
      setBuySellOpOrLocationCommodity(2);
    }
  }, [props.isSellLeads]);

  const getAllcity = async () => {
    let res = await CommonApiService.getAllCity();
    if (res?.data?.data) {
      setAllcitys(res.data.data);
    }
  };

  const onClickByBuyerSeller = (e) => {
    const { value } = e.target;
    setBuyerSeller(value);

    // if (buyerSeller?.includes(value)) {
    //   setBuyerSeller(buyerSeller.filter((val) => val !== value));
    // } else {
    //   setBuyerSeller([...buyerSeller, value]);
    // }
  };

  const onChangeMultiSelect = (e, name) => {
    setError({});
    setLocationAndCommodities((prev) => ({
      ...prev,
      [name]: e ? e.map((e) => e.label) : [],
    }));
  };

  const onNext = async () => {
    if (buyerSeller.length === 0) {
      setError((prev) => ({ ...prev, buyerSeller: "Select Options" }));
      return false;
    }
    // let data_1 = { "preferred_user_types": buyerSeller }
    // let res = await authServices.addUserType(data_1)
    // if (res?.data?.data) {
    //   setBuySellOpOrLocationCommodity(2)
    // }

    if (buyerSeller != "bank" && buyerSeller != "Broker")
      setBuySellOpOrLocationCommodity(2);
    else
      props.changeFormType(
        3,
        buyerSeller === "Broker" ? "brokerSelected" : "bankSelected"
      );
  };

  const saveCommoditiesAndLocations = async () => {
    let data = {
      preferred_buyer_locations: locationAndCommodities.buyerLocation,
      preferred_buyer_commodities: locationAndCommodities.buyerCommodity,
      preferred_seller_locations: locationAndCommodities.sellerLocation,
      preferred_seller_commodities: locationAndCommodities.sellerCommodity,
    };
    let buySellerArray = ["buyer"];
    if (buyerSeller == "seller") buySellerArray = ["seller"];
    else if (buyerSeller == "buyer-seller")
      buySellerArray = ["buyer", "seller"];
    let obj = validateBuySell(locationAndCommodities, buySellerArray);
    if (obj) {
      setError(obj);
    }

    if (!obj) {
      let data_1 = { preferred_user_types: buySellerArray };
      await authServices.addUserType(data_1);
      let res = await authServices.addPreferredLocation(data);
      if (res?.data?.data) {
        localStorage.setItem("buysellcommodityLocationSaved", true);
        if (
          parseInt(localStorage.getItem("isKyc")) === 1 &&
          localStorage.getItem("isKyc") != "undefined" &&
          localStorage.getItem("isKyc") != undefined &&
          localStorage.getItem("isKyc") != "null"
        ) {
          if (props.close) {
            props.close();
          }
          // if (props.noKYC) {
          //   props.close()
          // }
          props.changeFormType(3);
        } else {
          // if (props.noKYC) {
          //   props.close()
          // }
          props.changeFormType(3);
        }
      }
    }
  };
  if (props?.history?.location?.pathname.includes("/auction/") && props.close) {
    props.close();
  }
  return (
    <div className="filterbx p-1 new_pox">
      {!props.isBuyLeads && isBuySellOpOrLocationCommodity === 2 && (
        <MdKeyboardBackspace
          className="key-f"
          color={"#5c6b25"}
          size="25"
          onClick={() => setBuySellOpOrLocationCommodity(1)}
        ></MdKeyboardBackspace>
      )}
      <div className="form-group">
        {isBuySellOpOrLocationCommodity === 1 && (
          <div>
            <form className="poxlogin">
              <label>
                <MultiLanguageTranslation title="Do you want to proceed further as a?" />
              </label>
              {!window.selectSupplyClick && (
                <div className="selectradio">
                  <div className="selectoption buysellCheckbox">
                    <label for="BUYER">
                      <input
                        onChange={onClickByBuyerSeller}
                        checked={buyerSeller == "buyer"}
                        className="m-2"
                        type="radio"
                        id="user"
                        name="buyer"
                        value="buyer"
                      />
                      {/* <span class="w_checkmark"></span> */}
                      Buyer
                    </label>
                  </div>
                </div>
              )}
              <div className="selectradio">
                <div className="selectoption buysellCheckbox">
                  <label htmlFor="SELLAR">
                    <input
                      onChange={onClickByBuyerSeller}
                      checked={buyerSeller == "seller"}
                      className="m-2"
                      type="radio"
                      id="user"
                      name="seller"
                      value="seller"
                    />
                    {/* <span class="w_checkmark"></span> */}
                    Seller
                  </label>
                </div>
              </div>
              <div className="selectradio">
                <div className="selectoption buysellCheckbox">
                  <label htmlFor="BUYER-SELLER">
                    <input
                      onChange={onClickByBuyerSeller}
                      checked={buyerSeller == "buyer-seller"}
                      className="m-2"
                      type="radio"
                      id="user"
                      name="buyer-seller"
                      value="buyer-seller"
                    />
                    {/* <span class="w_checkmark"></span> */}
                    Buyer and Seller
                  </label>
                </div>
              </div>
              {!(parseInt(isKyc) === 1) && !fromTrade && (
                <div className="selectradio">
                  <div className="selectoption buysellCheckbox">
                    <label htmlFor="Bank">
                      <input
                        onChange={onClickByBuyerSeller}
                        checked={buyerSeller == "bank"}
                        className="m-2"
                        type="radio"
                        id="user"
                        name="bank"
                        value="bank"
                      />
                      {/* <span class="w_checkmark"></span> */}
                      Lender (Banks, NBFC’s)
                    </label>
                  </div>
                </div>
              )}

              {!(parseInt(isKyc) === 1) && !fromTrade && (
                <div className="selectradio">
                  <div className="selectoption buysellCheckbox">
                    <label htmlFor="Broker">
                      <input
                        onChange={onClickByBuyerSeller}
                        checked={buyerSeller == "Broker"}
                        className="m-2"
                        type="radio"
                        id="user"
                        name="broker"
                        value="Broker"
                      />
                      Broker
                    </label>
                  </div>
                </div>
              )}
            </form>
            {error?.buyerSeller && (
              <div className="fromerror">{error.buyerSeller}</div>
            )}
            <div className="mt-4">
              <a
                href="javascript:void(0)"
                className="form-control posubmit"
                style={{
                  backgroundColor: "#e08701",
                  textAlign: "center",
                  color: "#fff",
                  fontWeight: "600",
                  cursor: "pointer",
                }}
                onClick={() => onNext()}
              >
                NEXT
              </a>
            </div>
          </div>
        )}

        {isBuySellOpOrLocationCommodity === 2 && (
          <div>
            <form className="poxlogin new_buyer_seller">
              {buyerSeller?.includes("buyer") && (
                <div className="newpoBX">
                  <label>
                    <MultiLanguageTranslation title="Your preferred locations and commodities as a Buyer" />
                  </label>
                  <div className="form-group mt-2 pologin">
                    <label for="BUYER" className="polabel">
                      Locations
                    </label>
                    <MultiSelect
                      placeholder="Locations"
                      className="form-control poinput"
                      options={allcitys}
                      onChange={(e) => onChangeMultiSelect(e, "buyerLocation")}
                      selected={locationAndCommodities?.buyerLocation}
                    ></MultiSelect>
                    {error?.buyerLocation && (
                      <div className="fromerror">{error.buyerLocation}</div>
                    )}
                  </div>
                  <div className="form-group mt-2 pologin">
                    <label for="BUYER">Commodities</label>
                    {options_master && (
                      <MultiSelect
                        placeholder="Commodities"
                        menuPlacement="top"
                        className="form-control poinput"
                        options={options_master.commodity}
                        onChange={(e) =>
                          onChangeMultiSelect(e, "buyerCommodity")
                        }
                        selected={locationAndCommodities?.buyerCommodity}
                      ></MultiSelect>
                    )}
                    {error?.buyerCommodity && (
                      <div className="fromerror">{error.buyerCommodity}</div>
                    )}
                  </div>
                </div>
              )}
              {buyerSeller?.includes("seller") && (
                <div className="newpoBX">
                  <label>
                    <MultiLanguageTranslation title="Your preferred locations and commodities as a Seller" />
                  </label>
                  <div className="form-group mt-2 pologin">
                    <label for="BUYER">Locations</label>
                    <MultiSelect
                      placeholder="Locations"
                      menuPlacement={
                        buyerSeller == "buyer-seller" ? "top" : "bottom"
                      }
                      className="form-control poinput"
                      options={allcitys}
                      onChange={(e) => onChangeMultiSelect(e, "sellerLocation")}
                      selected={locationAndCommodities?.sellerLocation}
                    ></MultiSelect>
                    {error?.sellerLocation && (
                      <div className="fromerror">{error.sellerLocation}</div>
                    )}
                  </div>
                  <div className="form-group mt-2 pologin">
                    <label for="BUYER">Commodities</label>
                    {options_master && (
                      <MultiSelect
                        placeholder="Commodities"
                        menuPlacement="top"
                        className="form-control poinput"
                        options={options_master.commodity}
                        onChange={(e) =>
                          onChangeMultiSelect(e, "sellerCommodity")
                        }
                        selected={locationAndCommodities?.sellerCommodity}
                      ></MultiSelect>
                    )}
                    {error?.sellerCommodity && (
                      <div className="fromerror">{error.sellerCommodity}</div>
                    )}
                  </div>
                </div>
              )}
            </form>
            <div className="mt-4">
              <a
                href="javascript:void(0)"
                className="form-control posubmit"
                style={{
                  backgroundColor: "#e08701",
                  textAlign: "center",
                  color: "#fff",
                  fontWeight: "600",
                  cursor: "pointer",
                }}
                onClick={() => saveCommoditiesAndLocations()}
              >
                NEXT
              </a>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default LoginSignupForm;
